// extracted by mini-css-extract-plugin
module.exports = {"Tab":"Tab_Tab__3kSRG","Tab__enables":"Tab_Tab__enables__XrvUf"};